import {
  ObjectValidatorsMap,
  ObjectMapValidator,
  regexValidator,
} from '../../../components/Validator';

const ShareUserValidatorMap: ObjectValidatorsMap<object> = {
  email: regexValidator(/\S+@\S+\.\S+/, 'Given value is not a valid email address.'),
}

const ShareUserValidator = new ObjectMapValidator<object>(ShareUserValidatorMap);

export default ShareUserValidator;